import { render, staticRenderFns } from "./QuiltyResourceTable.vue?vue&type=template&id=0ad512bc&"
import script from "./QuiltyResourceTable.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports